<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <v-card class="white rounded-lg" >
          <v-card-title class="secondary--text">{{ title }}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <m-datatable :show-filter-row="false" :headers="cols" :apiUrl="baseUrl"
                         ref="datatable" :show-select="true" :filters.sync="filters"
                         @dblclick:row="(e, row) => $router.push(toOrder(row.item.id))">
            </m-datatable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import cart from "@/components/scomponents/Cart";
import UserSelect from "@/components/selects/UserSelect";
import Swal from "sweetalert2";


export default {
  name: "AffiliateAdminOrderPackages",
  mixins: [MFormMixin, formsMixin, FormsMixin],
  components: {
    UserSelect,
    cart
  },

  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'packing/affiliateAdminOrderPackages',
      baseUrl: "packing/affiliateAdminOrderPackages",
      permissionBasename: "order_package",
      appendSlash: false,
      payFromWallet: false,
      hasList: false,
      discountCode: "",
      discountAmount: 0,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      admin: null,
      isDefinable: false,
      pay_amount: 0,
      myClass: '',
      ss: null,
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      first: false,
      filters: {

      },
      cols: [
        {
          text: "نام کسب و کار",
          value: "business.name",
        },
        {
          text: "نام مشتری",
          value: "customer_name",
        },
        {
          text: "تعداد اقلام",
          value: "products_quantity",
          type: 'numeric'
        },
        {
          text: " بسته بندی شده",
          value: "is_packaged",
          type: 'boolean'
        },
        {
          text: "زمان بسته بندی",
          value: "packing_data_time",
        },
        {
          text: " پست شده",
          value: "is_shipped",
          type: 'boolean'
        },
        {
          text: "زمان پست",
          value: "shipping_data_time",
        },
      ],

    };
  },
  computed: {
    title() {
      return ' گزارش  سفارشات'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
  },
  methods: {
    toOrder(id) {
      return {
        name: "OrderPackage",
        params: {
          id: id,
        },
      };
    },

  },
}
</script>

<style scoped lang="scss"></style>

